<template>
	<router-view></router-view>
</template>

<script>
export default {
  name: 'Main'
}
</script>

<style>
</style>